import { DebugEx } from '@Utils/DebugEx';
import { setGlobal } from '@Utils/Globals';
import { showToastNotification } from '@Primitive/ToastNotification';
import { EmeraldBaseUri } from '@Utils/Paths';
import { InfoTipItemType, MapButtonSettings } from '@Primitive/InfoTips';
// ================================================================================================
// Init firebase messaging
var FireBaseNotification = async (registration: ServiceWorkerRegistration) => {
    try {
        const firebase = await import("firebase/app");
        const firebaseMessage = await import("firebase/messaging");

        // Your web app's Firebase configuration
        var firebaseConfig = {
            apiKey: "AIzaSyAiNSd0HwMg34E6jbph07oAEPsAQP-MN4M",
            projectId: "emerald-65905",
            messagingSenderId: "782077220061",
            appId: "1:782077220061:web:94c8652304d3f951297734",
        };
        // Initialize Firebase
        const app = firebase.initializeApp(firebaseConfig);

        // Init messaging
        const messaging = firebaseMessage.getMessaging(app);
        await Notification.requestPermission();
        const token = await firebaseMessage.getToken(messaging, { vapidKey: "BCBOTjpQnoePmmqRZtPW348DiH6l1lax-tfz-qI8QpNVk1jqAOX8eY9NeLP7VnPYEKg7zPlWdIvJ54Mg93OHRAk", serviceWorkerRegistration: registration });
        console.error('token for user:', token);
        if (!token) {
            // Show permission request.
            console.log('No Instance ID token available. Request permission to generate one.');
        }

        // Set in global variable the token
        setGlobal("web-push-notification-token", token);

        // Send the message to worker to handling it there
        firebaseMessage.onMessage(messaging, (payload) => {
            console.error('Message received. ', payload);
            registration.active.postMessage(payload)
        });
    } catch (ex) {
        DebugEx.TraceError('Firebase', ex);
    }
}
// ================================================================================================
var deferredPrompt;
// -------------------------------------------------------------------------------------------------
export function PWAUnInit() {
    DebugEx.TraceLog("[PWA] Uninit PWA started");
    if ('serviceWorker' in navigator) {
        // Remove all the old registrations
        navigator.serviceWorker
            .getRegistrations()
            .then(registrations => {
                for (let registration of registrations)
                    registration.unregister();
            });
    }
}
// -------------------------------------------------------------------------------------------------
export async function PWAInit() {
    DebugEx.TraceLog("[PWA] Init PWA started");
    if ('serviceWorker' in navigator) {
        window.addEventListener('load', async () => {
            try {
                DebugEx.TraceLog("[PWA] Start workbox loading");
                const { Workbox } = await import('workbox-window');
                const wb = new Workbox((EmeraldBaseUri + "/sw.js").replace("//", "/"));
                wb.addEventListener('activated', (event) => {
                    // `event.isUpdate` will be true if another version of the service
                    // worker was controlling the page when this version was registered.
                    if (!event.isUpdate) {
                        console.log('[PWA] Service worker activated for the first time!');

                        // If your service worker is configured to precache assets, those
                        // assets should all be available now.
                    }
                });

                wb.addEventListener('installed', (event) => {
                    // If this is not the very first service worker install (event.isUpdate === true),
                    // it means a newer version of the service worker has been found and installed 
                    // (that is, a different version from the one currently controlling the page).
                    if (event.isUpdate) {
                        DebugEx.TraceDebug('[PWA] New Version of Emerald is ready refresh the page!!!!');

                        showToastNotification({
                            Type: 'default',
                            Position: 'top-right',
                            AdvanceBody: {
                                icon: 'far fa-bullhorn',
                                title: 'Update Available',
                                subtitle: 'We just released a new version',
                                backgroundColor: '#1769aa',
                                fontColor: 'white',
                                items: [{
                                    type: InfoTipItemType.button,
                                    label: 'Refresh',
                                    value: null,
                                    style: {
                                        height: '25px'
                                    },
                                    settings: {
                                        shadowLevel: 0,
                                        backgroundColor: '#ab003c'
                                    } as MapButtonSettings
                                }]
                            },
                            AdvanceBodyStyle: {
                                padding: 10
                            },
                            Autoclose: false,
                            HideProgressBar: true,
                            CloseButton: false,
                            Title: '',
                            Body: '',
                            Icon: ''
                        }, () => {
                            window.location.reload();
                        });
                    }
                });

                wb.addEventListener('waiting', (event) => {
                    console.error(`[PWA] A new service worker has installed, but it can't activate` +
                        `until all tabs running the current version have fully unloaded.`);
                });

                DebugEx.TraceDebug('[PWA] Start SW registration');
                let service = await wb.register();

                DebugEx.TraceDebug('[PWA] SW registered: ', service);
                await FireBaseNotification(service);

                DebugEx.TraceDebug('[PWA] SW registered completed');
            }
            catch (ex) {
                DebugEx.TraceException(ex, '[PWA] SW registration failed');
            }
        });
    }
    // --------------------------------------------------------------------------------------------
    window.addEventListener('beforeinstallprompt', function (e) {
        // Prevent Chrome 67 and earlier from automatically showing the prompt
        e.preventDefault();
        // Stash the event so it can be triggered later.
        deferredPrompt = e;
    });
}
// --------------------------------------------------------------------------------------------
export function PWACanBeInstall() {
    return deferredPrompt != null;
}
// --------------------------------------------------------------------------------------------
export function PWARequestUserInstall() {
    if (deferredPrompt != null) {
        deferredPrompt.prompt();  // Wait for the user to respond to the prompt
        deferredPrompt.userChoice
            .then(function (choiceResult) {
                if (choiceResult.outcome === 'accepted') {
                    console.log('User accepted the A2HS prompt');
                } else {
                    console.log('User dismissed the A2HS prompt');
                }
                deferredPrompt = null;
            });
    }
}
// --------------------------------------------------------------------------------------------